/**
 * Is this page being served from a tenant's own address (`jane-realty.flashsuite.net`)
 * rather than the operator app? On a tenant host the path IS the register slug
 * (`register_url` is `https://<subdomain>.flashsuite.net/<slug>`), and the API
 * resolves the workspace from the Host header, so the router only has to send
 * `/:slug` to the public register page.
 */
const OUR_HOSTS = new Set(["www", "demo", "api", "videos", "cdn", "connect"]);

/** Where the operator app lives, and the one address Flashsuite sends people back to. */
export const APP_ORIGIN = "https://flashroom.flashsuite.ai";

/** Where the operator app itself is served from, in development as in production. */
const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "[::1]"]);
const SUFFIX = ".flashsuite.net";

export function isTenantHost(hostname: string): boolean {
  const host = hostname.toLowerCase().split(":")[0];
  if (!host || LOCAL_HOSTS.has(host) || host.endsWith(".local")) return false;
  if (host === new URL(APP_ORIGIN).hostname) return false;
  if (host.endsWith(".workers.dev") || host.endsWith(".pages.dev")) return false;
  if (host === "flashsuite.net") return false;
  if (host.endsWith(SUFFIX)) {
    const sub = host.slice(0, -SUFFIX.length);
    return sub.length > 0 && !OUR_HOSTS.has(sub);
  }
  // Anything else is a host's own domain, pointed at us. The API still resolves
  // the workspace from the Host header, so an address we do not know 404s.
  return true;
}
